var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{style:(( _vm.fixedIt === true ? 'width: -webkit-fill-available;position:fixed;' : '' ))},[_c('app-header'),_c('router-view')],1),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }